import React from "react";
import styles from "../../static/css/pages.module.css";
import InputDiv from "../../components/form/input/input_div";
import Icon from "../../components/icons/icons";
import Moment from "react-moment";
import ServerRegister from "../server/register";
import ieSvg from "../../components/icons/ieSvg";
import moment from "moment";

class ProfileDetails extends React.Component {
  componentDidMount() {
    ieSvg();
  }

  componentDidUpdate() {
    ieSvg();
  }

  render() {
    if (this.props.details.data.items) {
      switch (this.props.details.data.items.result.status) {
        case "TIMEOUT" :
          return (
            <div className="l-align_center">
              <div className={styles.article}>&nbsp;</div>
              <div className={styles.serviceIcon}>
                <Icon name="icon_error-data" viewbox="0 0 227 120"/>
              </div>
              Сбой загрузки информации<br/>
              Вернитесь на страницу позже
              <div className={styles.article}>&nbsp;</div>
              <div className={styles.article}>&nbsp;</div>
              <div className={styles.article}>&nbsp;</div>
            </div>
          );
        case "ERROR":
          switch (this.props.details.data.items.result.errorCode) {
            case "TAXPAYER_UNBOUND":
            case "TAXPAYER_UNREGISTERED":
              return <ServerRegister errorMessage={this.props.details.data.items.result.errorMessage}/>;
            default:
              return (
                <div className="l-align_center">
                  <div className={styles.article}>&nbsp;</div>
                  <div className={styles.serviceIcon}>
                    <Icon name="icon_error-data" viewbox="0 0 227 120"/>
                  </div>
                  Данные не получены.<br/>
                  {this.props.details.data.items.result.errorMessage}
                  <div className={styles.article}>&nbsp;</div>
                  <div className={styles.article}>&nbsp;</div>
                  <div className={styles.article}>&nbsp;</div>
                </div>
              )
          }
        default: {
          const {
            fio,
            regDate,
            unregDate,
            unregReason,
            activities,
            region,
            phone,
            email,
            accountNumber,
            lastUpdateDate,
            regCertificateNumber
          } = this.props.details.data.items.data;
          return (
              <React.Fragment>
                <InputDiv label="ФИО" value={fio}/>

                <div className="l-grid l-grid_time">
                  <div className="l-grid__item_6">
                    <InputDiv label="Дата последней постановки на учет"
                              value={
                                <Moment format="DD MMMM YYYY" local>
                                  {moment.utc(regDate)}
                                </Moment>}
                              underinput={
                                <div>
                                  <Moment format="DD.MM.YYYY HH:mm" local>
                                    {moment.utc(regDate)}
                                  </Moment>
                                </div>}
                    />
                  </div>
                  {unregDate ? <div className="l-grid__item_6">
                    <InputDiv label="Дата последнего снятия с учета"
                              value={
                                <Moment format="DD MMMM YYYY" local>
                                  {moment.utc(unregDate)}
                                </Moment>}
                              underinput={
                                <div>
                                  <Moment format="DD.MM.YYYY HH:mm" local>
                                    {moment.utc(unregDate)}
                                  </Moment>
                                </div>}
                    />
                  </div>: null}
                </div>
                {unregReason ? <InputDiv label="Причина снятия с учета" value={unregReason}/>: null}
                {activities ? <InputDiv label="Виды деятельности" value={activities.join(', ')}/> : null}
                <InputDiv label="Регион преимущественного ведения деятельности на текущий отчетный период"
                          value={region}/>
                <InputDiv label="Номер телефона" value={phone}/>
                {email ? <InputDiv label="E-mail" value={email}/>: null}
                {accountNumber ? <InputDiv label="Номер счета для уплаты налога" value={accountNumber}/>: null}
                {lastUpdateDate ?
                    <div className="l-grid l-grid_time">
                      <div className="l-grid__item_6">
                        <InputDiv label="Дата последнего обновления данных"
                                  value={
                                    <Moment format="DD MMMM YYYY" local>
                                      {moment.utc(lastUpdateDate)}
                                    </Moment>}
                                  underinput={<div>
                                    <Moment format="DD.MM.YYYY HH:mm" local>
                                      {moment.utc(lastUpdateDate)}
                                    </Moment>
                                  </div>}
                        />
                      </div>
                    </div> : null}
                {regCertificateNumber ? <InputDiv label="Номер свидетельства о постановке на учет" value={regCertificateNumber}/>: null}
                <div className={styles.article}/>
              </React.Fragment>
          )
        }
      }
    } else {
      return (
        <div className="l-align_center">
          <div className={styles.article}>&nbsp;</div>
          <div className={`${styles.loadingEl} ${styles.loadingInner}`}>
            <div className={styles.loader}/>
            Загружаем информацию о статусе...
          </div>
          <div className={styles.article}>&nbsp;</div>
          <div className={styles.article}>&nbsp;</div>
          <div className={styles.article}>&nbsp;</div>
        </div>
      )
    }
  }
}

export default ProfileDetails;
